export const apiConstants = {
  GetAllClubs: 'services/app/Clubs/GetAll',
  GetClub: 'services/app/Clubs/Get',
};
